import React, { useState } from "react";
import { Button, TextField, Paper, Dialog, DialogContent } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import axios from "../api/axios";
import image from "../assets/forgot.png";
import "./ForgotPassword.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [cooldown, setCooldown] = useState(0);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsSubmitting(true);

    try {
      await axios.post("/api/auth/v1/forgot-password", {
        email,
        frontend_url: window.location.origin,
      });

      setOpen(true);
      setCooldown(30);

      const interval = setInterval(() => {
        setCooldown((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } catch (err) {
      if (err?.response?.status === 404) {
        setErrorMessage("User does not exist");
      } else {
        setErrorMessage(err?.response?.data?.message || "Something went wrong");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="login-shell" style={{ fontFamily: "Work Sans" }}>
        <div className="brand-pane">
          <div className="forgot-illustration-wrapper">
            <img
              src={image}
              alt="Forgot Password"
              className="forgot-illustration"
            />
          </div>
        </div>

        <div className="form-pane">
          <Paper
            elevation={0}
            className="form-card"
            style={{ backgroundColor: "transparent" }}
          >
            <h2 className="form-title">Forgot your password?</h2>

            <p className="form-subtitle">
              Enter your email address and we’ll send you a reset link.
            </p>

            <form onSubmit={handleSubmit} noValidate>
              <div className="field">
                <TextField
                  fullWidth
                  label="Email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  variant="outlined"
                  margin="normal"
                  error={!!errorMessage}
                  helperText={errorMessage || " "}
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                />
              </div>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                className="login-cta"
                disabled={!email || isSubmitting}
              >
                {cooldown > 0 ? `Resend in ${cooldown}s` : "Send Reset Link"}
              </Button>
            </form>
          </Paper>
        </div>
      </div>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          className: "popup",
        }}
      >
        <DialogContent className="popup-content">
          <div className="popup-icon-wrapper">
            <CheckCircleIcon />
          </div>

          <h2>Password reset link sent</h2>

          <p>
            If an account exists for <strong>{email}</strong>, you’ll receive an
            email with instructions to reset your password.
          </p>
          <div>
            <Button
              fullWidth
              variant="contained"
              className="login-cta"
              onClick={() => navigate("/")}
            >
              Back to Login
            </Button>
            <Button
              fullWidth
              variant="outlined"
              className="login-ctx"
              onClick={() => setOpen(false)}
            >
              Close
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ForgotPassword;
